import { useEffect, useState } from 'react';
import classnames from 'classnames';

import './index.css';
import { useTranslation } from 'react-i18next';

const NumberButton = ({ value, onClick, active }) => {
  const classNames = classnames('numberButton', {
    active: active,
  });

  const handleClick = () => {
    onClick?.();
  };

  return (
    <span className={classNames} onClick={handleClick}>
      {value}
    </span>
  );
};

const BettingButton = ({ disabled }) => {
  const { t } = useTranslation();
  const classNames = classnames('bettingButton', {
    disabled: disabled,
  });

  return (
    <button className={classNames} disabled={disabled}>
      {t('LotteryBlock.board_bettingButton')}
    </button>
  );
};

const BettingLine = ({ prefix = '', numberArray = [], selected = [], onNumberButtonClick }) => {
  const [selectedNumbers, setSelectedNumbers] = useState(selected);

  const handleNumberButtonClick = value => {
    const numbers = new Set(selectedNumbers);
    if (numbers.has(value)) {
      numbers.delete(value);
    } else {
      numbers.add(value);
    }
    setSelectedNumbers(Array.from(numbers));
    onNumberButtonClick?.();
  };

  useEffect(() => {
    setSelectedNumbers(selected);
  }, [selected]);

  return (
    <div className="bettingLine">
      <span className="prefix">{prefix}</span>
      {numberArray.map(number => {
        return <NumberButton key={number} value={number} active={selectedNumbers.includes(number)} onClick={() => handleNumberButtonClick(number)} />;
      })}
      <BettingButton disabled={selectedNumbers.length === 0} />
    </div>
  );
};

export default BettingLine;
